<script setup lang="ts">
import { useRoute, useRouter } from 'vue-router'
import { useI18n } from 'vue-i18n'
import { Icon } from '@iconify/vue'

const route = useRoute()
const router = useRouter()
const { t } = useI18n()

const tabs = [
  {
    i18nKey: 'component.tabbar.home',
    type: 'route',
    path: '/home',
    active: 'solar:home-smile-angle-bold',
    inactive: 'solar:home-smile-angle-line-duotone',
  },
  {
    i18nKey: 'component.tabbar.recommend',
    type: 'route',
    path: '/theater',
    active: 'solar:video-library-bold-duotone',
    inactive: 'solar:video-library-line-duotone',
  },
  {
    i18nKey: 'component.tabbar.creation',
    type: 'route',
    path: '/creation',
    active: 'solar:add-square-bold',
    inactive: 'solar:add-square-broken',
  },
  {
    i18nKey: 'component.tabbar.live',
    type: 'external',
    url: 'https://www.acadsoc.com.cn/lps/duanxin/2026/02/26.html',
    active: 'solar:play-stream-bold',
    inactive: 'solar:play-stream-bold-duotone',
  },

  {
    i18nKey: 'component.tabbar.profile',
    type: 'route',
    path: '/profile',
    active: 'solar:user-bold-duotone',
    inactive: 'solar:user-broken',
  },
]

const isActive = (path: string) => route.path === path

const handleTabClick = (tab: { type: string; path?: string; url?: string }) => {
  if (tab.type === 'route' && tab.path) {
    router.push(tab.path)
  } else if (tab.type === 'external' && tab.url) {
    window.open(tab.url, '_blank')
  }
}
</script>

<template>
  <div
    class="fixed bottom-0 left-0 right-0 z-50 border-t border-gray-900 bg-gray-950"
    style="padding-bottom: env(safe-area-inset-bottom, 0px)"
  >
    <div class="flex h-14 items-center justify-around">
      <div
        v-for="tab in tabs"
        :key="tab.type === 'route' ? tab.path : tab.url"
        class="flex cursor-pointer flex-col items-center justify-center transition-colors duration-300 ease-out"
        :class="[isActive(tab.path ? tab.path : '') ? 'text-purple-500/80' : 'text-gray-400']"
        @click="handleTabClick(tab)"
      >
        <Icon
          class="text-[26px]"
          :class="tab.path === '/creation' ? 'size-10 text-white/60' : ''"
          :icon="isActive(tab.path ? tab.path : '') ? tab.active : tab.inactive"
        />
        <span v-if="tab.path !== '/creation'" class="mt-1 text-[11px] transition-colors duration-200">
          {{ t(tab.i18nKey) }}
        </span>
      </div>
    </div>
  </div>
</template>
